jQuery(document).on("nfFormReady", function () {
  // For each form field, add a callback so we know when the field was interacted with and has a value.
  const ninjaFormFields = [
    ...document.querySelectorAll(
      ".ninja-forms-field:not([type=button]):not([type=submit])"
    ),
  ];
  ninjaFormFields.forEach((field) => {
    field.addEventListener("blur", nightwingNinjaFormFieldOnBlur);
  });

  const sel = document.querySelector("#nf-field-15");

  if (!sel || sel.tagName !== "SELECT" || sel.DOCUMENT_POSITION_DISCONNECTED.length === 0) return;

  const first = sel.options[0];

  first.disabled = true;
  
});

// Add the 'is-filled' class to the blurred field's wrap element, so we know when the field was interacted with and has a value. This helps know when to move the floating field labels via CSS.
function nightwingNinjaFormFieldOnBlur(e) {
  const wrap = e.target.closest(".field-wrap");
  if (wrap && "" !== e.target.value) {
    wrap.classList.add("is-filled");
  }
}
